export default "__VITE_ASSET__B_A$4acP__"